import type { ConsentRequirement } from "dutyon-server/types";

export const CURRENT_SERVICE_TERMS_VERSION = "2024-01-01";
export const CURRENT_MARKETING_TERMS_VERSION = "2024-01-01";

export const getConsentRequirement = (error: unknown): ConsentRequirement | null => {
  if (!error || typeof error !== "object") return null;
  const response = (
    error as {
      response?: {
        status?: unknown;
        data?: { code?: unknown; requiredConsent?: Partial<ConsentRequirement> };
      };
    }
  ).response;
  if (response?.status !== 428 || response.data?.code !== "CONSENT_REQUIRED") return null;

  const serviceTermsVersion = response.data.requiredConsent?.serviceTermsVersion;
  const marketingTermsVersion = response.data.requiredConsent?.marketingTermsVersion;
  return {
    serviceTermsVersion:
      typeof serviceTermsVersion === "string" && serviceTermsVersion.length > 0
        ? serviceTermsVersion
        : CURRENT_SERVICE_TERMS_VERSION,
    marketingTermsVersion:
      typeof marketingTermsVersion === "string" && marketingTermsVersion.length > 0
        ? marketingTermsVersion
        : CURRENT_MARKETING_TERMS_VERSION,
  };
};

export const isConsentRequiredError = (error: unknown) => getConsentRequirement(error) !== null;
